<script setup lang="ts">
const props = defineProps({
  functionality: {
    type: Object,
    required: true,
  },
})

const title = props.functionality.name
const description = props.functionality.description
const icon = props.functionality.image.url
</script>

<template>
  <div class="flex flex-col items-center">
    <div class="bg-main-500 w-16 h-16 rounded-xl flex justify-center items-center">
      <img v-if="icon" :src="icon" :alt="title" class="block text-white fill-current h-10 w-10 select-none" />
    </div>
    <p class="mt-2 text-gray-800 font-bold text-center">
      {{ title }}
    </p>
    <p class="text-center prose-sm">
      {{ description }}
    </p>
  </div>
</template>
